class CartNote extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('change', (event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        });
    }
}

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
}
